/* eslint-disable max-len */
/**
 * CONSTANTS
 */
export const VALIDATE_DUPLICATE_DENOUNCES = "VALIDATE_DUPLICATE_DENOUNCES";
export const VALIDATE_DUPLICATE_DENOUNCES_FULFILLED = "VALIDATE_DUPLICATE_DENOUNCES_FULFILLED";
export const VALIDATE_DUPLICATE_DENOUNCES_ERROR = "VALIDATE_DUPLICATE_DENOUNCES_ERROR";
export const VALIDATE_DUPLICATE_DENOUNCES_RESET = "VALIDATE_DUPLICATE_DENOUNCES_RESET";

/**
 * DISPATCHERS
 */
export const validateDuplicateDenounces = payload => ({ type: VALIDATE_DUPLICATE_DENOUNCES, payload });
export const validateDuplicateDenouncesFulfilled = payload => ({ type: VALIDATE_DUPLICATE_DENOUNCES_FULFILLED, payload });
export const validateDuplicateDenounceError = payload => ({ type: VALIDATE_DUPLICATE_DENOUNCES_ERROR, payload });
export const validateDuplicateDenouncesReset = () => ({ type: VALIDATE_DUPLICATE_DENOUNCES_RESET });
